import { render } from "./fileAllocation.vue?vue&type=template&id=1cd3b5e5"
import script from "./fileAllocation.vue?vue&type=script&lang=js"
export * from "./fileAllocation.vue?vue&type=script&lang=js"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__